import React, { useEffect, useState } from "react";
import { Input, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";

import BulkAddInspirationGallery from "./view/inspiration-gallery-bulk-add-view";
import { getInspirationCategorydata } from "./store/category/category-slice";
import "./css/inspiration-gallery-layout.css";

const { Option } = Select;

const InspirationGalleryHeader = ({ filters, setFilters }) => {
    const dispatch = useDispatch();

    /* ---------------- State ---------------- */

    const [searchValue, setSearchValue] = useState(() => filters.search || "");

    const { categoryList, isLoading } = useSelector(
        (state) => state.inspirationCategorySlice
    );

    /* Browser back / forward: keep input aligned with query string */
    useEffect(() => {
        setSearchValue(filters.search || "");
    }, [filters.search]);

    /* Debounce typing → URL (skip if already matches, avoids wiping ?q= on mount) */
    useEffect(() => {
        const delay = setTimeout(() => {
            const next = (searchValue || "").trim();
            setFilters((prev) => {
                const cur = (prev.search || "").trim();
                if (cur === next) return prev;
                return { ...prev, search: next };
            });
        }, 500);

        return () => clearTimeout(delay);
    }, [searchValue, setFilters]);

    /* ---------------- Handlers ---------------- */
    const updateFilters = (key, value) => {
        setFilters((prev) => ({ ...prev, [key]: value }));
    };

    /* ---------------- UI ---------------- */
    return (
        <div className="inspiration-gallery-toolbar">
            <Input
                allowClear
                size="large"
                className="inspiration-gallery-toolbar__search"
                prefix={<SearchOutlined className="inspiration-gallery-toolbar__search-icon" />}
                placeholder="Search inspiration..."
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
            />
            <div className="inspiration-gallery-toolbar__filters">
                <Select
                    size="large"
                    className="inspiration-gallery-toolbar__select inspiration-gallery-toolbar__select--platform"
                    placeholder="Platform"
                    value={filters.platform}
                    onChange={(value) => updateFilters("platform", value)}
                >
                    <Option value="Web">Web</Option>
                    <Option value="Mobile">Mobile</Option>
                </Select>
                <Select
                    size="large"
                    className="inspiration-gallery-toolbar__select inspiration-gallery-toolbar__select--category"
                    placeholder="Category"
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    loading={isLoading}
                    value={filters.category}
                    onChange={(value) => updateFilters("category", value)}
                    onDropdownVisibleChange={(open) => {
                        if (open) dispatch(getInspirationCategorydata());
                    }}
                    options={categoryList?.map((item) => ({
                        value: item._id,
                        label: item.name,
                    }))}
                />
            </div>
            <div className="inspiration-gallery-toolbar__actions">
                <BulkAddInspirationGallery />
            </div>
        </div>
    );
};

export default InspirationGalleryHeader;
